/*
 * Coffee Specifications Section
 * CVA-aligned three-panel carousel: Origin, Craft, Character
 * Initializes Flickity carousel for mobile layout (< 768px)
 */

(function() {
  'use strict';

  var BREAKPOINT = 768;
  var initialized = false;
  var carouselInstance = null;

  function initCoffeeSpecs() {
    var section = document.querySelector('.coffee-specs-section');
    if (!section) return;

    var carousel = section.querySelector('[data-coffee-specs-carousel]');
    var nav = section.querySelector('[data-coffee-specs-nav]');

    if (!carousel || !nav) return;

    // Desktop: destroy carousel if active
    if (window.innerWidth >= BREAKPOINT) {
      destroyCoffeeSpecs();
      return;
    }

    // Already initialized
    if (initialized) return;

    // Wait for Flickity to be available (Turbo theme loads it async)
    if (typeof Flickity === 'undefined') {
      setTimeout(initCoffeeSpecs, 100);
      return;
    }

    // Initialize Flickity carousel
    carouselInstance = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      draggable: true,
      wrapAround: false,
      adaptiveHeight: true
    });

    // Set first nav item as selected
    syncNav(0);

    // Sync nav on carousel change
    carouselInstance.on('change', function(index) {
      syncNav(index);
    });

    // Nav click handlers
    var navItems = nav.querySelectorAll('.coffee-specs-nav-item');
    navItems.forEach(function(item, index) {
      item.addEventListener('click', function() {
        if (carouselInstance) {
          carouselInstance.select(index);
        }
      });
    });

    initialized = true;
  }

  function syncNav(index) {
    var nav = document.querySelector('[data-coffee-specs-nav]');
    if (!nav) return;

    var navItems = nav.querySelectorAll('.coffee-specs-nav-item');
    navItems.forEach(function(item, i) {
      if (i === index) {
        item.classList.add('is-selected', 'is-nav-selected');
      } else {
        item.classList.remove('is-selected', 'is-nav-selected');
      }
    });
  }

  function destroyCoffeeSpecs() {
    if (carouselInstance) {
      carouselInstance.destroy();
      carouselInstance = null;
    }
    initialized = false;
  }

  function handleResize() {
    clearTimeout(handleResize.timer);
    handleResize.timer = setTimeout(function() {
      if (window.innerWidth >= BREAKPOINT) {
        destroyCoffeeSpecs();
      } else {
        initCoffeeSpecs();
      }
    }, 250);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCoffeeSpecs);
  } else {
    initCoffeeSpecs();
  }

  // Handle viewport changes
  window.addEventListener('resize', handleResize);

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.coffee-specs-section')) {
      setTimeout(initCoffeeSpecs, 100);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target.querySelector('.coffee-specs-section')) {
      destroyCoffeeSpecs();
    }
  });

})();